var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRotatePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 9.5H11.5C10.3954 9.5 9.5 10.3954 9.5 11.5V40.5C9.5 41.6046 10.3954 42.5 11.5 42.5H28.5C29.6046 42.5 30.5 41.6046 30.5 40.5V11.5C30.5 10.3954 29.6046 9.5 28.5 9.5Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 54.5C23.7044 54.5 22.9413 54.1839 22.3787 53.6213C21.8161 53.0587 21.5 52.2956 21.5 51.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 54.5C52.2956 54.5 53.0587 54.1839 53.6213 53.6213C54.1839 53.0587 54.5 52.2956 54.5 51.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 42.5V45.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 42.5V45.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 54.5H35",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41 54.5H45.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 33.5C52.2956 33.5 53.0587 33.8161 53.6213 34.3787C54.1839 34.9413 54.5 35.7044 54.5 36.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 33.5H35",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M41 33.5H45.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8799 11L35.4399 14.44C35.2996 14.5786 35.1883 14.7436 35.1122 14.9256C35.0362 15.1076 34.9971 15.3028 34.9971 15.5C34.9971 15.6972 35.0362 15.8924 35.1122 16.0744C35.1883 16.2564 35.2996 16.4214 35.4399 16.56L38.8799 20",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25.12L47.44 28.56C47.5786 28.7003 47.7436 28.8117 47.9256 28.8877C48.1076 28.9637 48.3028 29.0029 48.5 29.0029C48.6972 29.0029 48.8924 28.9637 49.0744 28.8877C49.2564 28.8117 49.4214 28.7003 49.56 28.56L53 25.12",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35 15.5H42.5C44.0913 15.5 45.6174 16.1321 46.7426 17.2574C47.8679 18.3826 48.5 19.9087 48.5 21.5V29",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRotatePhone);
export default __webpack_public_path__ + "static/media/icon-rotate-phone.da27e80bc8d9a7b667bfb40bfd158451.svg";
export { ForwardRef as ReactComponent };